export class LearnerDetail {
  registrationId?: string
  emailAddress: string
  emailExists: boolean = false
  sameAsPrimaryContact?: boolean
  firstName?: string
  lastName?: string
  phoneNumber?: string
  birthYear?: number
  optinforEmail?: boolean
  optinforSMS?: boolean
  selected?: boolean
  isPrimaryLearner?: boolean
  isPrimary?: boolean
  note?: string
  courseFee?: boolean;
  adminWorkCompleted?: boolean;
  eligibility?: boolean;
  messageForLearner?: string;
  LearnerOrder?:number;
  CreatedDate?: Date;

  constructor(emailAddress: string,
    emailExists: boolean = false,
    sameAsPrimaryContact?: boolean,
    firstName?: string,
    lastName?: string,
    phoneNumber?: string,
    birthYear?: number,
    optinforEmail?: boolean,
    optinforSMS?: boolean,
    registrationId?: string,
    selected?: boolean,
    isPrimaryLearner?: boolean,
    note?: string,
    courseFee?: boolean,
    adminWorkCompleted?: boolean,
    eligibility?: boolean,
    messageForLearner?: string,
    isPrimary?: boolean,
    learnerOrder?:number,
    CreatedDate?:Date){
    this.emailAddress = emailAddress
    this.emailExists = emailExists
    this.sameAsPrimaryContact = sameAsPrimaryContact
    this.firstName = firstName
    this.lastName = lastName
    this.phoneNumber = phoneNumber
    this.birthYear = birthYear
    this.optinforEmail = optinforEmail
    this.optinforSMS = optinforSMS
    this.registrationId = registrationId
    this.selected = selected
    this.isPrimaryLearner = isPrimaryLearner
    this.note = note
    this.courseFee = courseFee
    this.adminWorkCompleted = adminWorkCompleted
    this.eligibility = eligibility
    this.messageForLearner = messageForLearner
    this.isPrimary = isPrimary
    this.LearnerOrder = learnerOrder
    this.CreatedDate = CreatedDate
  }

}
